/* istanbul ignore file */
import { getProcedureResult } from 'iguazu-rpc';
import { getSelectedProduct, getProducts } from '@americanexpress/product-ducks';
import { ENABLE_ONEDATA_ENROLL_OFFER, ENABLE_ONEDATA_FEEDBACK } from './enableOnedata';

export const mapStateToProps = (state, ownProps) => ({
  pathname: ownProps.location.pathname,
  axpDomain: state.getIn(['config', 'domainGlobal']),
  shopsmallMerchantApiUrl: state.getIn(['config', 'shopsmallMerchantApiUrl']),
  gemUrl: state.getIn(['config', 'gemUrl']),
  blueboxpublic: state.getIn(['browser', 'cookies', 'blueboxpublic']),
  isAuthenticated: Boolean(getSelectedProduct(state)),
  selectedProduct: getSelectedProduct(state),
  productsList: getProducts(state),
  enrolledOffersListLocal: ENABLE_ONEDATA_ENROLL_OFFER
    ? state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'CreateMerchantMapOffersEnrollment'])
    : state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'updateOfferEnrollment']),
  merchantsFeedbackList: ENABLE_ONEDATA_FEEDBACK
    ? state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'CreateMerchantEditSuggestion'])
    : state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'updateMerchant']),
  matchingKeywordsIguazu: state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'loadKeywords']),
  typeaheadResults: state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'ReadMerchantPersonalizationTypeahead']),
  merchantOfferDetailsIguazu: state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'loadOffersMaps']),
  offersListIguazu: getProcedureResult({
    procedureName: 'loadOffers',
    args: {
      query: ownProps.location.query,
      pathname: ownProps.location.pathname,
      accountKey: getSelectedProduct(state),
    },
  })(state),
  readOffersResults: getProcedureResult({
    procedureName: 'ReadMerchantMapOffers',
    args: {
      query: ownProps.location.query,
      pathname: ownProps.location.pathname,
      accountKey: getSelectedProduct(state),
    },
  })(state),
  enrolledOffersListIguazu: getProcedureResult({
    procedureName: 'loadEnrolledOffers',
    args: {
      query: ownProps.location.query,
      pathname: ownProps.location.pathname,
      accountKey: getSelectedProduct(state),
    },
  })(state),
  readEnrolledOffersResults: getProcedureResult({
    procedureName: 'ReadMerchantMapEnrolledOffers',
    args: {
      query: ownProps.location.query,
      pathname: ownProps.location.pathname,
      accountKey: getSelectedProduct(state),
    },
  })(state),
  readMapsOfferResults: state.getIn(['modules', 'axp-maps-root', 'procedures', 'procedureCaches', 'ReadMerchantMapsTabOffers']),
});
